import { splitFilename } from '@thesavingsgroup/utils/splitFilename';
import isEmpty from 'lodash/isEmpty';

import { getRandomValue } from './getRandomValue';

export const addRandomValueToFilename = (filename: string): string => {
  if (isEmpty(filename)) {
    return '';
  }

  if (!filename.includes('.')) {
    return `${filename}-${getRandomValue()}`;
  }

  const { name, extension } = splitFilename(filename);
  return `${name}-${getRandomValue()}.${extension}`;
};
